import { GetColorInfo } from "../components/ColorRefinementList";
import { FilterLabelTranslations } from "./FilterLabelTranslations";

export const CustomCurrentRefinementsProps = (disabledFilters: string[]) => {
  return {
    clearRefinementsProps: {
      transformItems: (items) => {
        return items.filter((item) => !disabledFilters.includes(item));
      },
    },
    useCurrentRefinementsProps: {
      transformItems: (items) => {
        return items
          .filter((item) => !disabledFilters.includes(item.attribute))
          .map((item) => {
            item.label =
              item.label in FilterLabelTranslations
                ? FilterLabelTranslations[item.label]
                : item.label;
            if (item.attribute === "filterColor") {
              item.refinements = item.refinements.map((refinement) => {
                const colorInfo = GetColorInfo(refinement.label);
                refinement.label = colorInfo.label;
                return refinement;
              });
            }
            return item;
          });
      },
    },
  };
};
